/*

class to generate investigation

http://www.hl7.org/fhir/clinicalimpression-definitions.html#ClinicalImpression.investigation

{
  "code" : { code }, // R!  A name/code for the set
  "item" : [{ Reference(Observation|QuestionnaireResponse|FamilyMemberHistory| DiagnosticReport|RiskAssessment|ImagingStudy|Media) }] // Record of a specific investigation
}

*/
// Import variables
const Joi = require('joi');

// Import variables
const { joiValidateObj } = require('../datastructComponents');
const { codeSchema } = require('./code.class');

// Create schema
const schema = {
  code: Joi.object().keys( codeSchema ).required(),
  item: Joi.array().items( Joi.string().optional() ).optional(),
};

// Define class
class Investigation {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Investigation = Investigation;
exports.investigationSchema = schema;